<template>
    <v-edit-dialog
        :return-value.sync="controlModel"
        large
        persistent
        :cancel-text="$t('cancel')"
        :save-text="$t('change')"
        transition="slide-y-transition"
        @save="setValue(controlModel)"
    >
        <div class="text-decorated-underline">{{ existence }}</div>
        <template v-slot:input>
            <v-select
                v-model="controlModel"
                :label="$t('existence')"
                :items="existenceItems"
                item-text="name"
                item-value="id"
                color="teal lighten-2"
            ></v-select>
        </template>
    </v-edit-dialog>
</template>

<script>
    import { ProductsService } from "../../../services";

    export default {
        name: "ControlExistence",
        props: ['controlData'],
        data() {
            return {
                paramName: 'existence',
                controlModel: this.controlData.existence
            }
        },
        computed: {
            existenceItems(){
                return this.$store.getters.existence.map(item=>{
                    return {
                        id: item.id,
                        name: this.$t(item.name)
                    }
                })
            },
            existence(){
                let value;
                this.existenceItems.forEach(item=>{
                    if (item.id === this.controlModel) {
                        value = item.name;
                    }
                })
                return value
            }
        },
        methods: {
            setValue(value) {
                const paramData = {
                    productId: this.controlData.id,
                    value: value
                };

                let emitData = this.controlData;
                emitData['existence'] = value;

                this.updateParam(emitData, paramData);
            },
            updateParam(emitData, paramData) {

                ProductsService.updateParam(this.paramName, paramData)
                    .then(() => {
                        this.$emit('update', emitData);
                    })
                    .catch(err => console.log(err));
            }
        }
    }
</script>

<style scoped>

</style>
